module.exports = __webpack_public_path__ + "img/reviews.1bc7a71.jpeg";